import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  checkMfaOtp,
  setOtpIsValidation,
} from "../../../store/slices/mfa-otp.slice";

const MfaComponent = () => {
  const dispatch = useDispatch();

  const isLoadingCheckOtp = useSelector((state: any) => {
    return state.otp.isLoadingCheckOtp;
  });

  const isOtpLoaded = useSelector((state: any) => {
    return state.otp.isOtpLoaded;
  });

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const onSearchOTP = (e: any) => {
    if (e.target.value.length === 6) {
      dispatch(checkMfaOtp({ code: e.target.value }));
    } else {
      dispatch(setOtpIsValidation(false));
    }
  };

  return (
    <div className="d-flex justify-start items-start w-full flex-col">
      <div
        className="d-flex justify-start items-start"
        style={{
          width: "60%",
        }}
      >
        <div className="d-flex justify-center items-center w-full">
          <Form.Group style={{ width: "100%" }}>
            <Form.Label>OTP here</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter OTP"
              onKeyUp={(e) => onSearchOTP(e)}
            />
            {/* wrong otp */}
            {isOtpLoaded && !isOtpVerified ? (
              <div className="error-message">Invalid OTP</div>
            ) : null}
          </Form.Group>
          {isLoadingCheckOtp ? (
            <Spinner
              className="mt-4 ms-2"
              style={{ color: "#1976D2" }}
              animation="border"
              role="status"
              size="sm"
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : null}

          {!isLoadingCheckOtp && isOtpVerified ? (
            <FontAwesomeIcon
              icon={faCheck}
              className="mt-4 ms-2 fs-7"
              style={{ color: "1976D2" }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MfaComponent;
